function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _excluded = ["widget", "title"],
    _excluded2 = ["widget", "title"],
    _excluded3 = ["widget", "title"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import { getTemplate, getWidget, getUiOptions, isFixedItems, allowAdditionalItems, isCustomWidget, optionsList, TranslatableString, ITEMS_KEY } from '@rjsf/utils';
import cloneDeep from 'lodash/cloneDeep';
import _get from 'lodash/get';
import isObject from 'lodash/isObject';
import set from 'lodash/set';
import { nanoid } from 'nanoid';
/** Used to generate a unique ID for an element in a row */

function generateRowId() {
  return nanoid();
}
/** Converts the `formData` into `KeyedFormDataType` data, using the `generateRowId()` function to create the key
 *
 * @param formData - The data for the form
 * @returns - The `formData` converted into a `KeyedFormDataType` element
 */


function generateKeyedFormData(formData) {
  return !Array.isArray(formData) ? [] : formData.map(function (item) {
    return {
      key: generateRowId(),
      item: item
    };
  });
}
/** Converts `KeyedFormDataType` data into the inner `formData`
 *
 * @param keyedFormData - The `KeyedFormDataType` to be converted
 * @returns - The inner `formData` item(s) in the `keyedFormData`
 */


function keyedToPlainFormData(keyedFormData) {
  if (Array.isArray(keyedFormData)) {
    return keyedFormData.map(function (keyedItem) {
      return keyedItem.item;
    });
  }

  return [];
}
/** The `ArrayField` component is used to render a field in the schema that is of type `array`. It supports both normal
 * and fixed array, allowing user to add and remove elements from the array data.
 */


var ArrayField = /*#__PURE__*/function (_Component) {
  _inherits(ArrayField, _Component);

  var _super = _createSuper(ArrayField);

  /** Constructs an `ArrayField` from the `props`, generating the initial keyed data from the `formData`
   *
   * @param props - The `FieldProps` for this template
   */
  function ArrayField(props) {
    var _this;

    _classCallCheck(this, ArrayField);

    _this = _super.call(this, props);
    /** Returns the default form information for an item based on the schema for that item. Deals with the possibility
     * that the schema is fixed and allows additional items.
     */

    _this._getNewFormDataRow = function () {
      var _this$props = _this.props,
          schema = _this$props.schema,
          registry = _this$props.registry;
      var schemaUtils = registry.schemaUtils;
      var itemSchema = schema.items;

      if (isFixedItems(schema) && allowAdditionalItems(schema)) {
        itemSchema = schema.additionalItems;
      } // Cast this as a T to work around schema utils being for T[] caused by the FieldProps<T[], S, F> call on the class


      return schemaUtils.getDefaultFormState(itemSchema);
    };
    /** Callback handler for when the user clicks on the add button. Creates a new row of keyed form data at the end of
     * the list, adding it into the state, and then returning `onChange()` with the plain form data converted from the
     * keyed data
     *
     * @param event - The event for the click
     */


    _this.onAddClick = function (event) {
      _this._handleAddClick(event);
    };
    /** Callback handler for when the user clicks on the add button on an existing array element. Creates a new row of
     * keyed form data inserted at the `index`, adding it into the state, and then returning `onChange()` with the plain
     * form data converted from the keyed data
     *
     * @param index - The index at which the add button is clicked
     */


    _this.onAddIndexClick = function (index) {
      return function (event) {
        _this._handleAddClick(event, index);
      };
    };
    /** Callback handler for when the user clicks on the copy button on an existing array element. Clones the row of
     * keyed form data at the `index` into the next position in the state, and then returning `onChange()` with the plain
     * form data converted from the keyed data
     *
     * @param index - The index at which the copy button is clicked
     */


    _this.onCopyIndexClick = function (index) {
      return function (event) {
        if (event) {
          event.preventDefault();
        }

        var _this$props2 = _this.props,
            onChange = _this$props2.onChange,
            errorSchema = _this$props2.errorSchema;
        var keyedFormData = _this.state.keyedFormData; // refs #195: revalidate to ensure properly reindexing errors

        var newErrorSchema;

        if (errorSchema) {
          newErrorSchema = {};

          for (var idx in errorSchema) {
            var i = parseInt(idx);

            if (i <= index) {
              set(newErrorSchema, [i], errorSchema[idx]);
            } else if (i > index) {
              set(newErrorSchema, [i + 1], errorSchema[idx]);
            }
          }
        }

        var newKeyedFormDataRow = {
          key: generateRowId(),
          item: cloneDeep(keyedFormData[index].item)
        };

        var newKeyedFormData = _toConsumableArray(keyedFormData);

        if (index !== undefined) {
          newKeyedFormData.splice(index + 1, 0, newKeyedFormDataRow);
        } else {
          newKeyedFormData.push(newKeyedFormDataRow);
        }

        _this.setState({
          keyedFormData: newKeyedFormData,
          updatedKeyedFormData: true
        }, function () {
          return onChange(keyedToPlainFormData(newKeyedFormData), newErrorSchema);
        });
      };
    };
    /** Callback handler for when the user clicks on the remove button on an existing array element. Removes the row of
     * keyed form data at the `index` in the state, and then returning `onChange()` with the plain form data converted
     * from the keyed data
     *
     * @param index - The index at which the remove button is clicked
     */


    _this.onDropIndexClick = function (index) {
      return function (event) {
        if (event) {
          event.preventDefault();
        }

        var _this$props3 = _this.props,
            onChange = _this$props3.onChange,
            errorSchema = _this$props3.errorSchema;
        var keyedFormData = _this.state.keyedFormData; // refs #195: revalidate to ensure properly reindexing errors

        var newErrorSchema;

        if (errorSchema) {
          newErrorSchema = {};

          for (var idx in errorSchema) {
            var i = parseInt(idx);

            if (i < index) {
              set(newErrorSchema, [i], errorSchema[idx]);
            } else if (i > index) {
              set(newErrorSchema, [i - 1], errorSchema[idx]);
            }
          }
        }

        var newKeyedFormData = keyedFormData.filter(function (_, i) {
          return i !== index;
        });

        _this.setState({
          keyedFormData: newKeyedFormData,
          updatedKeyedFormData: true
        }, function () {
          return onChange(keyedToPlainFormData(newKeyedFormData), newErrorSchema);
        });
      };
    };
    /** Callback handler for when the user clicks on one of the move item buttons on an existing array element. Moves the
     * row of keyed form data at the `index` to the `newIndex` in the state, and then returning `onChange()` with the
     * plain form data converted from the keyed data
     *
     * @param index - The index of the item to move
     * @param newIndex - The index to where the item is to be moved
     */


    _this.onReorderClick = function (index, newIndex) {
      return function (event) {
        if (event) {
          event.preventDefault();
          event.currentTarget.blur();
        }

        var _this$props4 = _this.props,
            onChange = _this$props4.onChange,
            errorSchema = _this$props4.errorSchema;
        var newErrorSchema;

        if (errorSchema) {
          newErrorSchema = {};

          for (var idx in errorSchema) {
            var i = parseInt(idx);

            if (i == index) {
              set(newErrorSchema, [newIndex], errorSchema[index]);
            } else if (i == newIndex) {
              set(newErrorSchema, [index], errorSchema[newIndex]);
            } else {
              set(newErrorSchema, [idx], errorSchema[i]);
            }
          }
        }

        var keyedFormData = _this.state.keyedFormData;

        function reOrderArray() {
          // Copy item
          var _newKeyedFormData = keyedFormData.slice(); // Moves item from index to newIndex


          _newKeyedFormData.splice(index, 1);

          _newKeyedFormData.splice(newIndex, 0, keyedFormData[index]);

          return _newKeyedFormData;
        }

        var newKeyedFormData = reOrderArray();

        _this.setState({
          keyedFormData: newKeyedFormData
        }, function () {
          return onChange(keyedToPlainFormData(newKeyedFormData), newErrorSchema);
        });
      };
    };
    /** Callback handler used to deal with changing the value of the data in the array at the `index`. Calls the
     * `onChange` callback with the updated form data
     *
     * @param index - The index of the item being changed
     */


    _this.onChangeForIndex = function (index) {
      return function (value, newErrorSchema, id) {
        var _this$props5 = _this.props,
            formData = _this$props5.formData,
            onChange = _this$props5.onChange,
            errorSchema = _this$props5.errorSchema;
        var arrayData = Array.isArray(formData) ? formData : [];
        var newFormData = arrayData.map(function (item, i) {
          // We need to treat undefined items as nulls to have validation.
          // See https://github.com/tdegrunt/jsonschema/issues/206
          var jsonValue = typeof value === 'undefined' ? null : value;
          return index === i ? jsonValue : item;
        });
        onChange(newFormData, errorSchema && errorSchema && _objectSpread(_objectSpread({}, errorSchema), {}, _defineProperty({}, index, newErrorSchema)), id);
      };
    };
    /** Callback handler used to change the value for a checkbox */


    _this.onSelectChange = function (value) {
      var _this$props6 = _this.props,
          onChange = _this$props6.onChange,
          idSchema = _this$props6.idSchema;
      onChange(value, undefined, idSchema && idSchema.$id);
    };

    var _props$formData = props.formData,
        formData = _props$formData === void 0 ? [] : _props$formData;
    var keyedFormData = generateKeyedFormData(formData);
    _this.state = {
      keyedFormData: keyedFormData,
      updatedKeyedFormData: false
    };
    return _this;
  }
  /** React lifecycle method that is called when the props are about to change allowing the state to be updated. It
   * regenerates the keyed form data and returns it
   *
   * @param nextProps - The next set of props data
   * @param prevState - The previous set of state data
   */


  _createClass(ArrayField, [{
    key: "itemTitle",
    get:
    /** Returns the appropriate title for an item by getting first the title from the schema.items, then falling back to
     * the description from the schema.items, and finally the string "Item"
     */
    function get() {
      var _this$props7 = this.props,
          schema = _this$props7.schema,
          registry = _this$props7.registry;
      var translateString = registry.translateString;
      return _get(schema, [ITEMS_KEY, 'title'], _get(schema, [ITEMS_KEY, 'description'], translateString(TranslatableString.ArrayItemTitle)));
    }
    /** Determines whether the item described in the schema is always required, which is determined by whether any item
     * may be null.
     *
     * @param itemSchema - The schema for the item
     * @return - True if the item schema type does not contain the "null" type
     */

  }, {
    key: "isItemRequired",
    value: function isItemRequired(itemSchema) {
      if (Array.isArray(itemSchema.type)) {
        // While we don't yet support composite/nullable jsonschema types, it's
        // future-proof to check for requirement against these.
        return !itemSchema.type.includes('null');
      } // All non-null array item types are inherently required by design


      return itemSchema.type !== 'null';
    }
    /** Determines whether more items can be added to the array. If the uiSchema indicates the array doesn't allow adding
     * then false is returned. Otherwise, if the schema indicates that there are a maximum number of items and the
     * `formData` matches that value, then false is returned, otherwise true is returned.
     *
     * @param formItems - The list of items in the form
     * @returns - True if the item is addable otherwise false
     */

  }, {
    key: "canAddItem",
    value: function canAddItem(formItems) {
      var _this$props8 = this.props,
          schema = _this$props8.schema,
          uiSchema = _this$props8.uiSchema,
          registry = _this$props8.registry;

      var _getUiOptions = getUiOptions(uiSchema, registry.globalUiOptions),
          addable = _getUiOptions.addable;

      if (addable !== false) {
        // if ui:options.addable was not explicitly set to false, we can add
        // another item if we have not exceeded maxItems yet
        if (schema.maxItems !== undefined) {
          addable = formItems.length < schema.maxItems;
        } else {
          addable = true;
        }
      }

      return addable;
    }
    /** Callback handler for when the user clicks on the add or add at index buttons. Creates a new row of keyed form data
     * either at the end of the list (when index is not specified) or inserted at the `index` when it is, adding it into
     * the state, and then returning `onChange()` with the plain form data converted from the keyed data
     *
     * @param event - The event for the click
     * @param [index] - The optional index at which to add the new data
     */

  }, {
    key: "_handleAddClick",
    value: function _handleAddClick(event, index) {
      if (event) {
        event.preventDefault();
      }

      var _this$props9 = this.props,
          onChange = _this$props9.onChange,
          errorSchema = _this$props9.errorSchema;
      var keyedFormData = this.state.keyedFormData; // refs #195: revalidate to ensure properly reindexing errors

      var newErrorSchema;

      if (errorSchema) {
        newErrorSchema = {};

        for (var idx in errorSchema) {
          var i = parseInt(idx);

          if (index === undefined || i < index) {
            set(newErrorSchema, [i], errorSchema[idx]);
          } else if (i >= index) {
            set(newErrorSchema, [i + 1], errorSchema[idx]);
          }
        }
      }

      var newKeyedFormDataRow = {
        key: generateRowId(),
        item: this._getNewFormDataRow()
      };

      var newKeyedFormData = _toConsumableArray(keyedFormData);

      if (index !== undefined) {
        newKeyedFormData.splice(index, 0, newKeyedFormDataRow);
      } else {
        newKeyedFormData.push(newKeyedFormDataRow);
      }

      this.setState({
        keyedFormData: newKeyedFormData,
        updatedKeyedFormData: true
      }, function () {
        return onChange(keyedToPlainFormData(newKeyedFormData), newErrorSchema);
      });
    }
    /** Renders the `ArrayField` depending on the specific needs of the schema and uischema elements
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props10 = this.props,
          schema = _this$props10.schema,
          uiSchema = _this$props10.uiSchema,
          idSchema = _this$props10.idSchema,
          registry = _this$props10.registry;
      var schemaUtils = registry.schemaUtils,
          translateString = registry.translateString;

      if (!(ITEMS_KEY in schema)) {
        var uiOptions = getUiOptions(uiSchema);
        var UnsupportedFieldTemplate = getTemplate('UnsupportedFieldTemplate', registry, uiOptions);
        return _jsx(UnsupportedFieldTemplate, {
          schema: schema,
          idSchema: idSchema,
          reason: translateString(TranslatableString.MissingItems),
          registry: registry
        });
      }

      if (schemaUtils.isMultiSelect(schema)) {
        // If array has enum or uniqueItems set to true, call renderMultiSelect() to render the default multiselect widget or a custom widget, if specified.
        return this.renderMultiSelect();
      }

      if (isCustomWidget(uiSchema)) {
        return this.renderCustomWidget();
      }

      if (isFixedItems(schema)) {
        return this.renderFixedArray();
      }

      if (schemaUtils.isFilesArray(schema, uiSchema)) {
        return this.renderFiles();
      }

      return this.renderNormalArray();
    }
    /** Renders a normal array without any limitations of length
     */

  }, {
    key: "renderNormalArray",
    value: function renderNormalArray() {
      var _this2 = this;

      var _this$props11 = this.props,
          schema = _this$props11.schema,
          _this$props11$uiSchem = _this$props11.uiSchema,
          uiSchema = _this$props11$uiSchem === void 0 ? {} : _this$props11$uiSchem,
          errorSchema = _this$props11.errorSchema,
          idSchema = _this$props11.idSchema,
          name = _this$props11.name,
          title = _this$props11.title,
          _this$props11$disable = _this$props11.disabled,
          disabled = _this$props11$disable === void 0 ? false : _this$props11$disable,
          _this$props11$readonl = _this$props11.readonly,
          readonly = _this$props11$readonl === void 0 ? false : _this$props11$readonl,
          _this$props11$autofoc = _this$props11.autofocus,
          autofocus = _this$props11$autofoc === void 0 ? false : _this$props11$autofoc,
          _this$props11$require = _this$props11.required,
          required = _this$props11$require === void 0 ? false : _this$props11$require,
          registry = _this$props11.registry,
          onBlur = _this$props11.onBlur,
          onFocus = _this$props11.onFocus,
          idPrefix = _this$props11.idPrefix,
          _this$props11$idSepar = _this$props11.idSeparator,
          idSeparator = _this$props11$idSepar === void 0 ? '_' : _this$props11$idSepar,
          rawErrors = _this$props11.rawErrors;
      var keyedFormData = this.state.keyedFormData;
      var fieldTitle = schema.title || title || name;
      var schemaUtils = registry.schemaUtils,
          formContext = registry.formContext;
      var uiOptions = getUiOptions(uiSchema);

      var _schemaItems = isObject(schema.items) ? schema.items : {};

      var itemsSchema = schemaUtils.retrieveSchema(_schemaItems);
      var formData = keyedToPlainFormData(this.state.keyedFormData);
      var canAdd = this.canAddItem(formData);
      var arrayProps = {
        canAdd: canAdd,
        items: keyedFormData.map(function (keyedItem, index) {
          var key = keyedItem.key,
              item = keyedItem.item; // While we are actually dealing with a single item of type T, the types require a T[], so cast

          var itemCast = item;
          var itemSchema = schemaUtils.retrieveSchema(_schemaItems, itemCast);
          var itemErrorSchema = errorSchema ? errorSchema[index] : undefined;
          var itemIdPrefix = idSchema.$id + idSeparator + index;
          var itemIdSchema = schemaUtils.toIdSchema(itemSchema, itemIdPrefix, itemCast, idPrefix, idSeparator);
          return _this2.renderArrayFieldItem({
            key: key,
            index: index,
            name: name && "".concat(name, "-").concat(index),
            title: fieldTitle ? "".concat(fieldTitle, "-").concat(index + 1) : undefined,
            canAdd: canAdd,
            canMoveUp: index > 0,
            canMoveDown: index < formData.length - 1,
            itemSchema: itemSchema,
            itemIdSchema: itemIdSchema,
            itemErrorSchema: itemErrorSchema,
            itemData: itemCast,
            itemUiSchema: uiSchema.items,
            autofocus: autofocus && index === 0,
            onBlur: onBlur,
            onFocus: onFocus,
            rawErrors: rawErrors,
            totalItems: keyedFormData.length
          });
        }),
        className: "field field-array field-array-of-".concat(itemsSchema.type),
        disabled: disabled,
        idSchema: idSchema,
        uiSchema: uiSchema,
        onAddClick: this.onAddClick,
        readonly: readonly,
        required: required,
        schema: schema,
        title: fieldTitle,
        formContext: formContext,
        formData: formData,
        rawErrors: rawErrors,
        registry: registry
      };
      var Template = getTemplate('ArrayFieldTemplate', registry, uiOptions);
      return _jsx(Template, _objectSpread({}, arrayProps));
    }
    /** Renders an array using the custom widget provided by the user in the `uiSchema`
     */

  }, {
    key: "renderCustomWidget",
    value: function renderCustomWidget() {
      var _a;

      var _this$props12 = this.props,
          schema = _this$props12.schema,
          idSchema = _this$props12.idSchema,
          uiSchema = _this$props12.uiSchema,
          _this$props12$disable = _this$props12.disabled,
          disabled = _this$props12$disable === void 0 ? false : _this$props12$disable,
          _this$props12$readonl = _this$props12.readonly,
          readonly = _this$props12$readonl === void 0 ? false : _this$props12$readonl,
          _this$props12$autofoc = _this$props12.autofocus,
          autofocus = _this$props12$autofoc === void 0 ? false : _this$props12$autofoc,
          _this$props12$require = _this$props12.required,
          required = _this$props12$require === void 0 ? false : _this$props12$require,
          hideError = _this$props12.hideError,
          placeholder = _this$props12.placeholder,
          onBlur = _this$props12.onBlur,
          onFocus = _this$props12.onFocus,
          _this$props12$formDat = _this$props12.formData,
          items = _this$props12$formDat === void 0 ? [] : _this$props12$formDat,
          registry = _this$props12.registry,
          rawErrors = _this$props12.rawErrors,
          name = _this$props12.name;
      var widgets = registry.widgets,
          formContext = registry.formContext,
          globalUiOptions = registry.globalUiOptions,
          schemaUtils = registry.schemaUtils;

      var _getUiOptions2 = getUiOptions(uiSchema, globalUiOptions),
          widget = _getUiOptions2.widget,
          uiTitle = _getUiOptions2.title,
          options = _objectWithoutProperties(_getUiOptions2, _excluded);

      var Widget = getWidget(schema, widget, widgets);
      var label = (_a = uiTitle !== null && uiTitle !== void 0 ? uiTitle : schema.title) !== null && _a !== void 0 ? _a : name;
      var displayLabel = schemaUtils.getDisplayLabel(schema, uiSchema, globalUiOptions);
      return _jsx(Widget, {
        id: idSchema.$id,
        name: name,
        multiple: true,
        onChange: this.onSelectChange,
        onBlur: onBlur,
        onFocus: onFocus,
        options: options,
        schema: schema,
        uiSchema: uiSchema,
        registry: registry,
        value: items,
        disabled: disabled,
        readonly: readonly,
        hideError: hideError,
        required: required,
        label: label,
        hideLabel: !displayLabel,
        placeholder: placeholder,
        formContext: formContext,
        autofocus: autofocus,
        rawErrors: rawErrors
      });
    }
    /** Renders an array as a set of checkboxes
     */

  }, {
    key: "renderMultiSelect",
    value: function renderMultiSelect() {
      var _a;

      var _this$props13 = this.props,
          schema = _this$props13.schema,
          idSchema = _this$props13.idSchema,
          uiSchema = _this$props13.uiSchema,
          _this$props13$formDat = _this$props13.formData,
          items = _this$props13$formDat === void 0 ? [] : _this$props13$formDat,
          _this$props13$disable = _this$props13.disabled,
          disabled = _this$props13$disable === void 0 ? false : _this$props13$disable,
          _this$props13$readonl = _this$props13.readonly,
          readonly = _this$props13$readonl === void 0 ? false : _this$props13$readonl,
          _this$props13$autofoc = _this$props13.autofocus,
          autofocus = _this$props13$autofoc === void 0 ? false : _this$props13$autofoc,
          _this$props13$require = _this$props13.required,
          required = _this$props13$require === void 0 ? false : _this$props13$require,
          placeholder = _this$props13.placeholder,
          onBlur = _this$props13.onBlur,
          onFocus = _this$props13.onFocus,
          registry = _this$props13.registry,
          rawErrors = _this$props13.rawErrors,
          name = _this$props13.name;
      var widgets = registry.widgets,
          schemaUtils = registry.schemaUtils,
          formContext = registry.formContext,
          globalUiOptions = registry.globalUiOptions;
      var itemsSchema = schemaUtils.retrieveSchema(schema.items, items);
      var enumOptions = optionsList(itemsSchema, uiSchema);

      var _getUiOptions3 = getUiOptions(uiSchema, globalUiOptions),
          _getUiOptions3$widget = _getUiOptions3.widget,
          widget = _getUiOptions3$widget === void 0 ? 'select' : _getUiOptions3$widget,
          uiTitle = _getUiOptions3.title,
          options = _objectWithoutProperties(_getUiOptions3, _excluded2);

      var Widget = getWidget(schema, widget, widgets);
      var label = (_a = uiTitle !== null && uiTitle !== void 0 ? uiTitle : schema.title) !== null && _a !== void 0 ? _a : name;
      var displayLabel = schemaUtils.getDisplayLabel(schema, uiSchema, globalUiOptions);
      return _jsx(Widget, {
        id: idSchema.$id,
        name: name,
        multiple: true,
        onChange: this.onSelectChange,
        onBlur: onBlur,
        onFocus: onFocus,
        options: _objectSpread(_objectSpread({}, options), {}, {
          enumOptions: enumOptions
        }),
        schema: schema,
        uiSchema: uiSchema,
        registry: registry,
        value: items,
        disabled: disabled,
        readonly: readonly,
        required: required,
        label: label,
        hideLabel: !displayLabel,
        placeholder: placeholder,
        formContext: formContext,
        autofocus: autofocus,
        rawErrors: rawErrors
      });
    }
    /** Renders an array of files using the `FileWidget`
     */

  }, {
    key: "renderFiles",
    value: function renderFiles() {
      var _a;

      var _this$props14 = this.props,
          schema = _this$props14.schema,
          uiSchema = _this$props14.uiSchema,
          idSchema = _this$props14.idSchema,
          name = _this$props14.name,
          _this$props14$disable = _this$props14.disabled,
          disabled = _this$props14$disable === void 0 ? false : _this$props14$disable,
          _this$props14$readonl = _this$props14.readonly,
          readonly = _this$props14$readonl === void 0 ? false : _this$props14$readonl,
          _this$props14$autofoc = _this$props14.autofocus,
          autofocus = _this$props14$autofoc === void 0 ? false : _this$props14$autofoc,
          _this$props14$require = _this$props14.required,
          required = _this$props14$require === void 0 ? false : _this$props14$require,
          onBlur = _this$props14.onBlur,
          onFocus = _this$props14.onFocus,
          registry = _this$props14.registry,
          _this$props14$formDat = _this$props14.formData,
          items = _this$props14$formDat === void 0 ? [] : _this$props14$formDat,
          rawErrors = _this$props14.rawErrors;
      var widgets = registry.widgets,
          formContext = registry.formContext,
          globalUiOptions = registry.globalUiOptions,
          schemaUtils = registry.schemaUtils;

      var _getUiOptions4 = getUiOptions(uiSchema, globalUiOptions),
          _getUiOptions4$widget = _getUiOptions4.widget,
          widget = _getUiOptions4$widget === void 0 ? 'files' : _getUiOptions4$widget,
          uiTitle = _getUiOptions4.title,
          options = _objectWithoutProperties(_getUiOptions4, _excluded3);

      var Widget = getWidget(schema, widget, widgets);
      var label = (_a = uiTitle !== null && uiTitle !== void 0 ? uiTitle : schema.title) !== null && _a !== void 0 ? _a : name;
      var displayLabel = schemaUtils.getDisplayLabel(schema, uiSchema, globalUiOptions);
      return _jsx(Widget, {
        options: options,
        id: idSchema.$id,
        name: name,
        multiple: true,
        onChange: this.onSelectChange,
        onBlur: onBlur,
        onFocus: onFocus,
        schema: schema,
        uiSchema: uiSchema,
        value: items,
        disabled: disabled,
        readonly: readonly,
        required: required,
        registry: registry,
        formContext: formContext,
        autofocus: autofocus,
        rawErrors: rawErrors,
        label: label,
        hideLabel: !displayLabel
      });
    }
    /** Renders an array that has a maximum limit of items
     */

  }, {
    key: "renderFixedArray",
    value: function renderFixedArray() {
      var _this3 = this;

      var _this$props15 = this.props,
          schema = _this$props15.schema,
          _this$props15$uiSchem = _this$props15.uiSchema,
          uiSchema = _this$props15$uiSchem === void 0 ? {} : _this$props15$uiSchem,
          _this$props15$formDat = _this$props15.formData,
          formData = _this$props15$formDat === void 0 ? [] : _this$props15$formDat,
          errorSchema = _this$props15.errorSchema,
          idPrefix = _this$props15.idPrefix,
          _this$props15$idSepar = _this$props15.idSeparator,
          idSeparator = _this$props15$idSepar === void 0 ? '_' : _this$props15$idSepar,
          idSchema = _this$props15.idSchema,
          name = _this$props15.name,
          title = _this$props15.title,
          _this$props15$disable = _this$props15.disabled,
          disabled = _this$props15$disable === void 0 ? false : _this$props15$disable,
          _this$props15$readonl = _this$props15.readonly,
          readonly = _this$props15$readonl === void 0 ? false : _this$props15$readonl,
          _this$props15$autofoc = _this$props15.autofocus,
          autofocus = _this$props15$autofoc === void 0 ? false : _this$props15$autofoc,
          _this$props15$require = _this$props15.required,
          required = _this$props15$require === void 0 ? false : _this$props15$require,
          registry = _this$props15.registry,
          onBlur = _this$props15.onBlur,
          onFocus = _this$props15.onFocus,
          rawErrors = _this$props15.rawErrors;
      var keyedFormData = this.state.keyedFormData;
      var _this$props$formData = this.props.formData,
          items = _this$props$formData === void 0 ? [] : _this$props$formData;
      var fieldTitle = schema.title || title || name;
      var uiOptions = getUiOptions(uiSchema);
      var schemaUtils = registry.schemaUtils,
          formContext = registry.formContext;

      var _schemaItems = isObject(schema.items) ? schema.items : [];

      var itemSchemas = _schemaItems.map(function (item, index) {
        return schemaUtils.retrieveSchema(item, formData[index]);
      });

      var additionalSchema = isObject(schema.additionalItems) ? schemaUtils.retrieveSchema(schema.additionalItems, formData) : null;

      if (!items || items.length < itemSchemas.length) {
        // to make sure at least all fixed items are generated
        items = items || [];
        items = items.concat(new Array(itemSchemas.length - items.length));
      } // These are the props passed into the render function


      var canAdd = this.canAddItem(items) && !!additionalSchema;
      var arrayProps = {
        canAdd: canAdd,
        className: 'field field-array field-array-fixed-items',
        disabled: disabled,
        idSchema: idSchema,
        formData: formData,
        items: keyedFormData.map(function (keyedItem, index) {
          var key = keyedItem.key,
              item = keyedItem.item; // While we are actually dealing with a single item of type T, the types require a T[], so cast

          var itemCast = item;
          var additional = index >= itemSchemas.length;
          var itemSchema = (additional && isObject(schema.additionalItems) ? schemaUtils.retrieveSchema(schema.additionalItems, itemCast) : itemSchemas[index]) || {};
          var itemIdPrefix = idSchema.$id + idSeparator + index;
          var itemIdSchema = schemaUtils.toIdSchema(itemSchema, itemIdPrefix, itemCast, idPrefix, idSeparator);
          var itemUiSchema = additional ? uiSchema.additionalItems || {} : Array.isArray(uiSchema.items) ? uiSchema.items[index] : uiSchema.items || {};
          var itemErrorSchema = errorSchema ? errorSchema[index] : undefined;
          return _this3.renderArrayFieldItem({
            key: key,
            index: index,
            name: name && "".concat(name, "-").concat(index),
            title: fieldTitle ? "".concat(fieldTitle, "-").concat(index + 1) : undefined,
            canAdd: canAdd,
            canRemove: additional,
            canMoveUp: index >= itemSchemas.length + 1,
            canMoveDown: additional && index < items.length - 1,
            itemSchema: itemSchema,
            itemData: itemCast,
            itemUiSchema: itemUiSchema,
            itemIdSchema: itemIdSchema,
            itemErrorSchema: itemErrorSchema,
            autofocus: autofocus && index === 0,
            onBlur: onBlur,
            onFocus: onFocus,
            rawErrors: rawErrors,
            totalItems: keyedFormData.length
          });
        }),
        onAddClick: this.onAddClick,
        readonly: readonly,
        required: required,
        registry: registry,
        schema: schema,
        uiSchema: uiSchema,
        title: fieldTitle,
        formContext: formContext,
        errorSchema: errorSchema,
        rawErrors: rawErrors
      };
      var Template = getTemplate('ArrayFieldTemplate', registry, uiOptions);
      return _jsx(Template, _objectSpread({}, arrayProps));
    }
    /** Renders the individual array item using a `SchemaField` along with the additional properties required to be send
     * back to the `ArrayFieldItemTemplate`.
     *
     * @param props - The props for the individual array item to be rendered
     */

  }, {
    key: "renderArrayFieldItem",
    value: function renderArrayFieldItem(props) {
      var key = props.key,
          index = props.index,
          name = props.name,
          canAdd = props.canAdd,
          _props$canRemove = props.canRemove,
          canRemove = _props$canRemove === void 0 ? true : _props$canRemove,
          canMoveUp = props.canMoveUp,
          canMoveDown = props.canMoveDown,
          itemSchema = props.itemSchema,
          itemData = props.itemData,
          itemUiSchema = props.itemUiSchema,
          itemIdSchema = props.itemIdSchema,
          itemErrorSchema = props.itemErrorSchema,
          autofocus = props.autofocus,
          onBlur = props.onBlur,
          onFocus = props.onFocus,
          rawErrors = props.rawErrors,
          totalItems = props.totalItems,
          title = props.title;
      var _this$props16 = this.props,
          disabled = _this$props16.disabled,
          hideError = _this$props16.hideError,
          idPrefix = _this$props16.idPrefix,
          idSeparator = _this$props16.idSeparator,
          readonly = _this$props16.readonly,
          uiSchema = _this$props16.uiSchema,
          registry = _this$props16.registry,
          formContext = _this$props16.formContext;
      var _registry$fields = registry.fields,
          ArraySchemaField = _registry$fields.ArraySchemaField,
          SchemaField = _registry$fields.SchemaField,
          globalUiOptions = registry.globalUiOptions;
      var ItemSchemaField = ArraySchemaField || SchemaField;

      var _getUiOptions5 = getUiOptions(uiSchema, globalUiOptions),
          _getUiOptions5$ordera = _getUiOptions5.orderable,
          orderable = _getUiOptions5$ordera === void 0 ? true : _getUiOptions5$ordera,
          _getUiOptions5$remova = _getUiOptions5.removable,
          removable = _getUiOptions5$remova === void 0 ? true : _getUiOptions5$remova,
          _getUiOptions5$copyab = _getUiOptions5.copyable,
          copyable = _getUiOptions5$copyab === void 0 ? false : _getUiOptions5$copyab;

      var has = {
        moveUp: orderable && canMoveUp,
        moveDown: orderable && canMoveDown,
        copy: copyable && canAdd,
        remove: removable && canRemove,
        toolbar: false
      };
      has.toolbar = Object.keys(has).some(function (key) {
        return has[key];
      });
      return {
        children: _jsx(ItemSchemaField, {
          name: name,
          title: title,
          index: index,
          schema: itemSchema,
          uiSchema: itemUiSchema,
          formData: itemData,
          formContext: formContext,
          errorSchema: itemErrorSchema,
          idPrefix: idPrefix,
          idSeparator: idSeparator,
          idSchema: itemIdSchema,
          required: this.isItemRequired(itemSchema),
          onChange: this.onChangeForIndex(index),
          onBlur: onBlur,
          onFocus: onFocus,
          registry: registry,
          disabled: disabled,
          readonly: readonly,
          hideError: hideError,
          autofocus: autofocus,
          rawErrors: rawErrors
        }),
        className: 'array-item',
        disabled: disabled,
        canAdd: canAdd,
        hasCopy: has.copy,
        hasToolbar: has.toolbar,
        hasMoveUp: has.moveUp,
        hasMoveDown: has.moveDown,
        hasRemove: has.remove,
        index: index,
        totalItems: totalItems,
        key: key,
        onAddIndexClick: this.onAddIndexClick,
        onCopyIndexClick: this.onCopyIndexClick,
        onDropIndexClick: this.onDropIndexClick,
        onReorderClick: this.onReorderClick,
        readonly: readonly,
        registry: registry,
        schema: itemSchema,
        uiSchema: itemUiSchema
      };
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      // Don't call getDerivedStateFromProps if keyed formdata was just updated.
      if (prevState.updatedKeyedFormData) {
        return {
          updatedKeyedFormData: false
        };
      }

      var nextFormData = Array.isArray(nextProps.formData) ? nextProps.formData : [];
      var previousKeyedFormData = prevState.keyedFormData || [];
      var newKeyedFormData = nextFormData.length === previousKeyedFormData.length ? previousKeyedFormData.map(function (previousKeyedFormDatum, index) {
        return {
          key: previousKeyedFormDatum.key,
          item: nextFormData[index]
        };
      }) : generateKeyedFormData(nextFormData);
      return {
        keyedFormData: newKeyedFormData
      };
    }
  }]);

  return ArrayField;
}(Component);
/** `ArrayField` is `React.ComponentType<FieldProps<T[], S, F>>` (necessarily) but the `registry` requires things to be a
 * `Field` which is defined as `React.ComponentType<FieldProps<T, S, F>>`, so cast it to make `registry` happy.
 */


export default ArrayField;